// @ts-check

import React from 'react';
import { bool, func, object } from 'prop-types';
import useChangePassword from '../hooks/useChangePassword';
import ProfilePwdField from './ProfilePwdField';
import PaperComponent from 'containers/pages/menus/components/PaperComponent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LockIcon from '@mui/icons-material/Lock';
import Typography from '@mui/material/Typography';
import USER from 'containers/pages/profile/ts/profileEnum';

/**
 * @component ChangePassword
 * @param {Object} props
 * @param {boolean} props.open
 * @param {ProfileUser} props.user
 * @param {() => void} props.onOpen
 * @returns {JSX.Element}
 */
function ChangePassword({ open, user, onOpen }) {
	const { state, handler } = useChangePassword(user, onOpen);

	return (
		<Dialog
			open={open}
			fullWidth
			PaperComponent={PaperComponent}
			aria-labelledby="draggable-dialog-title"
		>
			<DialogTitle
				id="draggable-dialog-title"
				sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}
			>
				<LockIcon color="secondary" sx={{ fontSize: '3rem' }} />
				<Typography component="span" variant="h6" gutterBottom>
					CHANGE PASSWORD
				</Typography>
			</DialogTitle>
			<DialogContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '2.5rem',
					paddingTop: '1.5rem !important',
				}}
			>
				<ProfilePwdField
					name={USER.PASSWORD}
					label="Password"
					value={state.pwdObj[USER.PASSWORD]}
					valid={state.valid[USER.PASSWORD]}
					onChange={(e) => handler.onHandlePwd(e)}
				/>
				<ProfilePwdField
					name={USER.CONFIRM_PASSWORD}
					label="Confirm Password"
					value={state.pwdObj[USER.CONFIRM_PASSWORD]}
					valid={state.valid[USER.CONFIRM_PASSWORD]}
					onChange={(e) => handler.onHandlePwd(e)}
				/>
			</DialogContent>
			<DialogActions sx={{ paddingRight: '1.5rem', paddingBottom: '1.5rem' }}>
				<Button sx={{ minWidth: '6rem' }} variant="outlined" onClick={handler.onReset}>
					CANCEL
				</Button>
				<Button
					disabled={state.canNotSave}
					variant="outlined"
					onClick={handler.onUpdatePwd}
					sx={{ minWidth: '6rem' }}
				>
					SAVE
				</Button>
			</DialogActions>
		</Dialog>
	);
}

ChangePassword.propTypes = { open: bool, user: object, onOpen: func };

export default ChangePassword;
